<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
    <h4 class="modal-title" >{{TR "Modus auswählen"}}</h4>
</div>
<div class="modal-body">
    <div class="remote-popover-mode-selector">

        <img />
        <canvas/>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
    <button type="button" class="btn btn-primary js-remote-mode-selector-save">{{TR "Auswählen"}}</button>
</div>
